var map = {
	"./about-us/about-us-controller.js": "./_pages/about-us/about-us-controller.js",
	"./about-us/our-company/our-company-controller.js": "./_pages/about-us/our-company/our-company-controller.js",
	"./about-us/press-information/press-information-controller.js": "./_pages/about-us/press-information/press-information-controller.js",
	"./community/community-controller.js": "./_pages/community/community-controller.js",
	"./design/native-to-mac/native-to-mac-controller.js": "./_pages/design/native-to-mac/native-to-mac-controller.js",
	"./handoff/handoff-controller.js": "./_pages/handoff/handoff-controller.js",
	"./home/banner-subscription/banner-subscription-controller.js": "./_pages/home/banner-subscription/banner-subscription-controller.js",
	"./home/home-controller.js": "./_pages/home/home-controller.js",
	"./license/license_controller.js": "./_pages/license/license_controller.js",
	"./newsletter/feedback/form-controller.js": "./_pages/newsletter/feedback/form-controller.js",
	"./pricing/banner/banner-controller.js": "./_pages/pricing/banner/banner-controller.js",
	"./prototype/prototype-controller.js": "./_pages/prototype/prototype-controller.js",
	"./releases/releases-controller.js": "./_pages/releases/releases-controller.js",
	"./store/edu/form/form-controller.js": "./_pages/store/edu/form/form-controller.js",
	"./store/edu/user-info/user-info-controller.js": "./_pages/store/edu/user-info/user-info-controller.js",
	"./store/edu/workspace/workspace-controller.js": "./_pages/store/edu/workspace/workspace-controller.js",
	"./support/contact/form-controller.js": "./_pages/support/contact/form-controller.js",
	"./switch-to-sketch/hero/hero-controller.js": "./_pages/switch-to-sketch/hero/hero-controller.js",
	"./updates/updates-controller.js": "./_pages/updates/updates-controller.js",
	"./vs/vs-controller.js": "./_pages/vs/vs-controller.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./_pages sync recursive [_-]controller\\.js$";